<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      class="form"
      :rules="rules"
    >
      <el-form-item label="工单号（有规律自动生成）" prop="companyName">
        <el-input v-model="form.orderNum"></el-input>
      </el-form-item>
      <el-form-item label="员工号" prop="complaint">
        <el-input v-model="form.workNo"></el-input>
      </el-form-item>
      <el-form-item label="工单类型">
        <el-select v-model="form.type">
          <el-option label="咨询工单" value="0"></el-option>
          <el-option label="普通服务工单" value="1"></el-option>
          <el-option label="团购工单" value="2"></el-option>
          <el-option label="兑换工单" value="3"></el-option>
          <el-option label="实体服务工单" value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票类型">
        <el-select v-model="form.fpType">
          <el-option label="无发票" value="1"></el-option>
          <el-option label="有发票" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票单位" prop="fpCompany">
        <el-input v-model="form.fpCompany"></el-input>
      </el-form-item>
      <el-form-item label="普通客户ID 关联客户信息" prop="complaint">
        <el-input v-model="form.customer"></el-input>
      </el-form-item>
      <el-form-item label="新建工单员工号" prop="detailed">
        <el-input v-model="form.createSeatNo"></el-input>
      </el-form-item>
      <el-form-item label="新建工单人员姓名" prop="detailed">
        <el-input v-model="form.createSeatName"></el-input>
      </el-form-item>
      <el-form-item label="新建工单时间" prop="detailed">
        <el-input v-model="form.createTime"></el-input>
      </el-form-item>
      <el-form-item label="派发工单员工号" prop="detailed">
        <el-input v-model="form.distributeSeatNo"></el-input>
      </el-form-item>
      <el-form-item label="派发工单人员姓名" prop="remarks">
        <el-input t v-model="form.distributeSeatName"></el-input>
      </el-form-item>
      <el-form-item label="派发工单时间" prop="remarks">
        <el-input t v-model="form.distributeTime"></el-input>
      </el-form-item>
      <el-form-item label="处理工单员工号" prop="remarks">
        <el-input t v-model="form.doneSeatNo"></el-input>
      </el-form-item>
      <el-form-item label="处理工单人员姓名" prop="remarks">
        <el-input t v-model="form.doneSeatName"></el-input>
      </el-form-item>
      <el-form-item label="处理工单时间" prop="remarks">
        <el-input t v-model="form.doneTime"></el-input>
      </el-form-item>
      <el-form-item label="申请作废工单员工号" prop="remarks">
        <el-input t v-model="form.askCloseSeatNo"></el-input>
      </el-form-item>
      <el-form-item label="申请作废工单人员姓名" prop="remarks">
        <el-input t v-model="form.askCloseName"></el-input>
      </el-form-item>
      <el-form-item label="申请作废工单时间" prop="remarks">
        <el-input t v-model="form.askCloseTime"></el-input>
      </el-form-item>
      <el-form-item label="作废工单员工号" prop="remarks">
        <el-input t v-model="form.closeSeatNo"></el-input>
      </el-form-item>
      <el-form-item label="作废工单人员姓名" prop="remarks">
        <el-input t v-model="form.closeSeatName"></el-input>
      </el-form-item>
      <el-form-item label="作废工单时间" prop="remarks">
        <el-input t v-model="form.closeTime"></el-input>
      </el-form-item>
      <el-form-item label="回访工单员工号" prop="remarks">
        <el-input t v-model="form.callSeatNo"></el-input>
      </el-form-item>
      <el-form-item label="回访工单人员姓名" prop="remarks">
        <el-input t v-model="form.callSeatName"></el-input>
      </el-form-item>
      <el-form-item label="回访工单时间" prop="remarks">
        <el-input t v-model="form.callTime"></el-input>
      </el-form-item>

      <el-form-item label="回访信息" prop="fpCompany">
        <el-input v-model="form.hfinfo"></el-input>
      </el-form-item>
      <el-form-item label="回访客户满意度">
        <el-select v-model="form.star">
          <el-option label="满意" value="0"></el-option>
          <el-option label="一般" value="1"></el-option>
          <el-option label="不满意" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务内容ID" prop="complaint">
        <el-input v-model="form.serveProduct"></el-input>
      </el-form-item>

      <el-form-item label="原">
        <el-select v-model="form.serviceType">
          <el-option label="维修维护服务" value="0"></el-option>
          <el-option label="保洁类服务" value="1"></el-option>
          <el-option label="生活照料类" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="家庭服务工单中服务单价" prop="detailed">
        <el-input v-model="form.unitPrice"></el-input>
      </el-form-item>

      <el-form-item label="家庭服务工单中服务面积" prop="detailed">
        <el-input v-model="form.area"></el-input>
      </el-form-item>
      <el-form-item label="家庭服务工单中服务次数" prop="detailed">
        <el-input v-model="form.num"></el-input>
      </el-form-item>
      <el-form-item label="家庭服务工单中服务优惠" prop="detailed">
        <el-input v-model="form.des"></el-input>
      </el-form-item>
      <el-form-item label="生活服务工单故障现象" prop="remarks">
        <el-input t v-model="form.failure"></el-input>
      </el-form-item>
      <el-form-item label="生活服务工单服务保障" prop="remarks">
        <el-input t v-model="form.ensure"></el-input>
      </el-form-item>
      <el-form-item label="生活服务工单修复结果" prop="remarks">
        <el-input t v-model="form.result"></el-input>
      </el-form-item>
      <el-form-item label="服务内容价格" prop="remarks">
        <el-input t v-model="form.fixPrice"></el-input>
      </el-form-item>
      <el-form-item label="上门费" prop="remarks">
        <el-input t v-model="form.serveFee"></el-input>
      </el-form-item>
      <el-form-item label="材料费" prop="remarks">
        <el-input t v-model="form.materialPrice"></el-input>
      </el-form-item>
      <el-form-item label="总计价格" prop="remarks">
        <el-input t v-model="form.totalPrice"></el-input>
      </el-form-item>
      <el-form-item label="维修服务工单中服务优惠" prop="remarks">
        <el-input t v-model="form.desServe"></el-input>
      </el-form-item>
      <el-form-item label="维修服务工单中材料优惠" prop="remarks">
        <el-input t v-model="form.desMaterial"></el-input>
      </el-form-item>
      <el-form-item label="维修服务工单中上门优惠" prop="remarks">
        <el-input t v-model="form.desFee"></el-input>
      </el-form-item>
      <el-form-item label="照料服务工单中服务优惠" prop="remarks">
        <el-input t v-model="form.desCare"></el-input>
      </el-form-item>
      <el-form-item label="服务要求" prop="remarks">
        <el-input t v-model="form.serrequire"></el-input>
      </el-form-item>
      <el-form-item label="服务时间" prop="remarks">
        <el-input t v-model="form.sertime"></el-input>
      </el-form-item>
      <el-form-item label="机构点ID  关联机构信息" prop="remarks">
        <el-input t v-model="form.serveStation"></el-input>
      </el-form-item>

      <el-form-item label="申请作废理由" prop="remarks">
        <el-input t v-model="form.closeReason"></el-input>
      </el-form-item>
      <el-form-item
        label="提交人（将申请提交给xxx用户进行调整）"
        prop="remarks"
      >
        <el-input t v-model="form.closePerson"></el-input>
      </el-form-item>

      <el-form-item label="工单状态">
        <el-select v-model="form.serviceType">
          <el-option label="待派发" value="0"></el-option>
          <el-option label="待处理" value="1"></el-option>
          <el-option label="待回访" value="2"></el-option>
          <el-option label="服务完成" value="3"></el-option>
          <el-option label="待作废" value="4"></el-option>
          <el-option label="已作废" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单状态说明" prop="remarks">
        <el-input t v-model="form.statusDesc"></el-input>
      </el-form-item>
      <el-form-item label="客户类型说明" prop="remarks">
        <el-input t v-model="form.customerDesc"></el-input>
      </el-form-item>
      <el-form-item label="新增服务工单设置的服务次数" prop="remarks">
        <el-input t v-model="form.number"></el-input>
      </el-form-item>
      <el-form-item label="工单类型">
        <el-select v-model="form.serviceType">
          <el-option label="为民政服务工单" value="null"></el-option>
          <el-option label="为商业服务工单" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单的APP状态">
        <el-select v-model="form.serviceType">
          <el-option label="待接单" value="1"></el-option>
          <el-option label="已接单" value="2"></el-option>
          <el-option label="执行中" value="3"></el-option>
          <el-option label="已取消" value="4"></el-option>
          <el-option label="已完成" value="5"></el-option>
          <el-option label="已评价" value="6"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开始照片" prop="remarks">
        <img :src="form.picStart" alt="" style="width: 200px; height: 150px" />
        <!--                <el-input t v-model="form.picStart"></el-input>-->
        <!--                <el-upload-->
        <!--                        class="avatar-uploader"-->
        <!--                        :action="form.picStart"-->
        <!--                       >-->
        <!--                    <img v-if="imageUrl" :src="imageUrl" class="avatar">-->
        <!--                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        <!--                </el-upload>-->
      </el-form-item>
      <el-form-item label="结束照片" prop="remarks">
        <!--                <el-input t v-model="form.picFinished"></el-input>-->
        <img
          :src="form.picFinished"
          alt=""
          style="width: 200px; height: 150px"
        />
      </el-form-item>
      <el-form-item label="接单时间" prop="remarks">
        <el-input t v-model="form.timeGet"></el-input>
      </el-form-item>
      <el-form-item label="开始工作时间" prop="remarks">
        <el-input t v-model="form.timeStart"></el-input>
      </el-form-item>
      <el-form-item label="结束工作时间" prop="remarks">
        <el-input t v-model="form.timeEnd"></el-input>
      </el-form-item>
      <el-form-item label="工作时长" prop="remarks">
        <el-input t v-model="form.period"></el-input>
      </el-form-item>
      <el-form-item label="用户作出的星级评价" prop="remarks">
        <el-input t v-model="form.estimateLevel"></el-input>
      </el-form-item>

      <el-form-item label="用户作出的文字评价" prop="remarks">
        <el-input t v-model="form.estimate"></el-input>
      </el-form-item>
      <el-form-item label="用户作出的语音评价" prop="remarks">
        <el-input t v-model="form.estimateRecord"></el-input>
      </el-form-item>
      <el-form-item label="订单是否通过APP发布的">
        <el-select v-model="form.serviceType">
          <el-option label="不是" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="用户指定的工作截止时间" prop="remarks">
        <el-input t v-model="form.sertimeEnd"></el-input>
      </el-form-item>
      <el-form-item label="实际工作时长" prop="remarks">
        <el-input t v-model="form.realPeriod"></el-input>
      </el-form-item>
      <el-form-item label="实际工作时长，仅限导出功能使用" prop="remarks">
        <el-input t v-model="form.shiTime"></el-input>
      </el-form-item>
      <el-form-item label="是否上门">
        <el-select v-model="form.serviceType">
          <el-option label="未上门" value="0"></el-option>
          <el-option label="已上门" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否享有实体服务的订单，与Customer的isFree相关">
        <el-select v-model="form.serviceType">
          <el-option label="不享有实体服务" value="0"></el-option>
          <el-option label="享有实体服务" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否已付款">
        <el-select v-model="form.serviceType">
          <el-option label="未付款" value="0"></el-option>
          <el-option label="已付款" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="应付金额，单位为分" prop="remarks">
        <el-input t v-model="form.amountPayable"></el-input>
      </el-form-item>
      <el-form-item label="支付宝金额，单位为分" prop="remarks">
        <el-input t v-model="form.amountAlipay"></el-input>
      </el-form-item>

      <el-form-item label="微信金额，单位为分" prop="remarks">
        <el-input t v-model="form.amountWx"></el-input>
      </el-form-item>
      <el-form-item label="银联金额，单位为分" prop="remarks">
        <el-input t v-model="form.amountUpmp"></el-input>
      </el-form-item>
      <el-form-item label="翼支付金额，单位为分" prop="remarks">
        <el-input t v-model="form.amountBestPay"></el-input>
      </el-form-item>
      <el-form-item label="现金，单位为分" prop="remarks">
        <el-input t v-model="form.cash"></el-input>
      </el-form-item>
      <el-form-item label="兴康币金额，单位分" prop="remarks">
        <el-input t v-model="form.amountCoupon"></el-input>
      </el-form-item>
      <el-form-item label="退款金额，单位为分" prop="remarks">
        <el-input t v-model="form.refund"></el-input>
      </el-form-item>

      <el-form-item label="血压-低压" prop="remarks">
        <el-input t v-model="form.pressureLow"></el-input>
      </el-form-item>
      <el-form-item label="血压-高压" prop="remarks">
        <el-input t v-model="form.pressureHigh"></el-input>
      </el-form-item>
      <el-form-item label="心率" prop="remarks">
        <el-input t v-model="form.sugarEmpty"></el-input>
      </el-form-item>
      <el-form-item label="血糖-血浆" prop="remarks">
        <el-input t v-model="form.sugarPlasma"></el-input>
      </el-form-item>
      <el-form-item label="数据来源" prop="remarks">
        <el-input t v-model="form.datafrom"></el-input>
      </el-form-item>

      <el-form-item label="加盟商评价" prop="remarks">
        <el-input t v-model="form.jiamengEstimate"></el-input>
      </el-form-item>
      <el-form-item label="主服务人员ID" prop="remarks">
        <el-input t v-model="form.servePersonID"></el-input>
      </el-form-item>
      <el-form-item label="主服务人员姓名" prop="remarks">
        <el-input t v-model="form.servePersonName"></el-input>
      </el-form-item>
      <el-form-item label="主服务人员电话" prop="remarks">
        <el-input t v-model="form.servePersonPhone"></el-input>
      </el-form-item>
      <el-form-item label="从服务人员姓名" prop="remarks">
        <el-input t v-model="form.otherservePersonName"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="remarks">
        <el-input t v-model="form.customerName"></el-input>
      </el-form-item>
      <el-form-item label="服务内容名称" prop="remarks">
        <el-input t v-model="form.serveproductName"></el-input>
      </el-form-item>
      <el-form-item label="机构名称" prop="remarks">
        <el-input t v-model="form.servestationName"></el-input>
      </el-form-item>
      <el-form-item label="同步码" prop="remarks">
        <el-input t v-model="form.sysEndCood"></el-input>
      </el-form-item>
      <el-form-item label="老人详细地址" prop="remarks">
        <el-input t v-model="form.community"></el-input>
      </el-form-item>

      <div class="button" v-if="buttonType == 'add'">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
      <div class="button" v-if="buttonType == 'compile'">
        <el-button type="primary" @click="save">编辑</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["buttonType", "row"],
  data() {
    return {
      form: {
        province: "",
      },
      rules: {},
    }
  },
  created() {
    this.form = this.row
  },
}
</script>

<style scoped>
.left {
  width: 45%;
  display: inline-block;
}

.right {
  width: 50%;
  display: inline-block;
  float: right;
}

.form {
  width: 90%;
}

.flex {
  display: flex;
}

.itemSelect {
  width: 30%;
}

.map {
  width: 100%;
  height: 120px;
  background-color: red;
}

.button {
  width: 400px;
  margin: 30px auto 0px;
  display: flex;
  justify-content: space-between;
}

.el-form-item {
  margin-bottom: 20px !important;
}

.el-form-item__label {
  line-height: 20px !important;
}

.el-radio {
  margin: 20px;
}
</style>
